<template>
    <v-flex>
      <v-card>
          <v-card-text class="caption">
              <v-layout>
                  <loading-progress-bar :loading="loading"></loading-progress-bar>
                  <v-spacer></v-spacer><span class="grey--text">{{facility_name}} {{equipment_name}}</span>
              </v-layout>
          </v-card-text>
          <v-card-text>
              <vue-plotly ref="plotly" :data="data" :layout="layout" :options="options"/>
          </v-card-text>
      </v-card>
  </v-flex>
</template>

<script>
import VuePlotly from '@/components/VuePlotly'
import {getTimeSeries} from '@/helper'
import LoadingProgressBar from '../LoadingProgressBar'

export default {
  props: {
    title: {type: String, default: ''},
    equipment_name: {type: String, default: 'Chiller 1'},
    variableX: {type: String, default: 'Refrigerant_Temp'},
    variableY: {type: String, default: 'Refrigerant_Press'},
    dateRange: {type: Object, default: null},
    type: {type: String, default: 'scattergl'},
      typeFilter: {type: String, default: null},
    onOnly: {type:Boolean, default: false}
  },
  components: {
    LoadingProgressBar,
    VuePlotly
  },
  computed: {
    facility_name () {
      return this.$store.state.pointsListStore.pointsList.facility_name
    },
    layout(){
      return {
        title: this.title,
        hovermode: 'closest',
        xaxis: {
          title: this.variableX
        },
        yaxis: {
          title: this.type==='histogram'? 'Count' : this.variableY
        },
        barmode: "overlay"
      }
    },
    equipment_names () {
        if(!this.typeFilter){
            return this.$store.state.pointsListStore.pointsList.equipment_names
        } else {
            let output = []
            for (let i in this.$store.state.pointsListStore.pointsList.equipment_details) {
                    let equip = this.$store.state.pointsListStore.pointsList.equipment_details[i]
                    if(this.typeFilter.includes(',')){
                        let splited=this.typeFilter.split(',');
                        for(let value of splited){
                            if (equip.equipment_type.toLowerCase()==value.toLowerCase()){
                                output.push(equip.equipment_name)     // push to array if matching filter
                                break
                            }
                        }
                    } else {
                        if (equip.equipment_type.toLowerCase()==this.typeFilter.toLowerCase()){
                            output.push(equip.equipment_name)               // push to array if matching filter
                        }
                    }
            }
            return output;
        }
    }
  },
  name: 'RefrigerantTempPressurePlot',
  watch: {
    variableX () {
      this.refresh()
    },
    variableY () {
      this.refresh()
    },
    equipment_names() {
      this.refresh()
    },
    dateRange () {
      this.refresh()
    },
    onOnly () {
      this.refresh()
    }
  },
  data: function () {
    return {
      data:[],
      options: {},
      df: null,
      timeout:null,
      loading: true
    }
    },
  methods: {
      debounce(callback, wait) {
          clearTimeout(this.timeout);
          this.timeout= setTimeout(() => callback(), wait);
      },
      refresh(){
          this.debounce(this.doRefresh,200);
      },
      doRefresh() {
      this.loading = true
          let me=this;
          let promises=[];
      for (let equip in this.equipment_names) {
          promises.push(getTimeSeries(
          [this.variableX, this.variableY],
          this.equipment_names[equip],
          this.$store.state.pointsListStore.pointsList.facility_name,
          this.dateRange,
          null,
          this.onOnly
        ));
      }
          Promise.all(promises).then(function(reses) {
              let newData=[];
              for (let equip in me.equipment_names) {
                  let df=reses[equip];
                  newData.push(
                      {
                          x: me.type==='timeseries'? df['Timestamp']:df[me.variableX],
                          y: df[me.variableY],
                          type: me.type==='timeseries'? 'scattergl':me.type,
                          mode: 'markers',
                          name: me.equipment_names[equip],
                          opacity: me.type==='histogram'? 0.5:1.0,
                          xbins: { size: 0.2, start: 0 }
                      }
                  )
              }
              me.data=newData;
              me.loading=false;
          });


    }

  },
   mounted () {
     this.refresh()
  }
}
</script>
